// date-pipe-shared.module.ts
import { NgModule } from '@angular/core';
import { ExtendDatePipe } from '../operate/common/src/lib/pipes/extend-date.pipe';

@NgModule({
  declarations: [ExtendDatePipe],
  exports: [ExtendDatePipe],
})
export class DatePipeSharedModule {}